var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1A5C4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9801 18.0341H17.571L19.3949 20.4119L20.2557 21.4688L23.1619 25.2614H20.4688L18.5256 22.7301L17.8608 21.8097L14.9801 18.0341ZM23.7244 14.9659C23.7244 16.8295 23.3835 18.4318 22.7017 19.7727C22.0199 21.108 21.0852 22.1364 19.8977 22.858C18.7159 23.5739 17.3722 23.9318 15.8665 23.9318C14.3551 23.9318 13.0057 23.5739 11.8182 22.858C10.6364 22.1364 9.70455 21.1051 9.02273 19.7642C8.34091 18.4233 8 16.8239 8 14.9659C8 13.1023 8.34091 11.5028 9.02273 10.1676C9.70455 8.8267 10.6364 7.7983 11.8182 7.08239C13.0057 6.3608 14.3551 6 15.8665 6C17.3722 6 18.7159 6.3608 19.8977 7.08239C21.0852 7.7983 22.0199 8.8267 22.7017 10.1676C23.3835 11.5028 23.7244 13.1023 23.7244 14.9659ZM21.1165 14.9659C21.1165 13.5455 20.8864 12.3494 20.4261 11.3778C19.9716 10.4006 19.3466 9.66193 18.5511 9.16193C17.7614 8.65625 16.8665 8.40341 15.8665 8.40341C14.8608 8.40341 13.9631 8.65625 13.1733 9.16193C12.3835 9.66193 11.7585 10.4006 11.2983 11.3778C10.8437 12.3494 10.6165 13.5455 10.6165 14.9659C10.6165 16.3864 10.8437 17.5852 11.2983 18.5625C11.7585 19.5341 12.3835 20.2727 13.1733 20.7784C13.9631 21.2784 14.8608 21.5284 15.8665 21.5284C16.8665 21.5284 17.7614 21.2784 18.5511 20.7784C19.3466 20.2727 19.9716 19.5341 20.4261 18.5625C20.8864 17.5852 21.1165 16.3864 21.1165 14.9659Z",
    fill: "#DBEFBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.1e7b3a3504d052ceade3af27d7d1ea72.svg";
export { ForwardRef as ReactComponent };